import { useRef, useEffect } from 'react';

/**
 * Keeps a ref always in sync with the latest value of a prop or state.
 * Useful for reading current values inside event listeners or callbacks
 * that were set up once (e.g. inside a map initialization useEffect).
 *
 * @param {*} value - The value to track
 * @returns {React.MutableRefObject} A ref whose .current is always up to date
 */
export const useLatestRef = value => {
	const ref = useRef(value);
	useEffect(() => {
		ref.current = value;
	});
	return ref;
};
